import { render, staticRenderFns } from "./RegisterAlianza.vue?vue&type=template&id=a8eaeaf8"
import script from "./RegisterAlianza.vue?vue&type=script&lang=js"
export * from "./RegisterAlianza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8eaeaf8')) {
      api.createRecord('a8eaeaf8', component.options)
    } else {
      api.reload('a8eaeaf8', component.options)
    }
    module.hot.accept("./RegisterAlianza.vue?vue&type=template&id=a8eaeaf8", function () {
      api.rerender('a8eaeaf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/alianzas/components/RegisterAlianza.vue"
export default component.exports